<template>
  <div class="formContainer">

    <form class="formularioBusqueda" @submit.prevent="loadOrderData">

      <div class="formGroup">
        <label>Periodo</label>

        <input
          type="text"
          v-model.trim="selectedPeriod"
          placeholder="Ingrese el periodo"
          required
        />
      </div>

      <div class="formGroup">
        <label>Cliente</label>

        <input
          type="text"
          v-model.trim="selectedClient"
          placeholder="Ingrese el cliente"
          required
        />
      </div>

      <div class="formGroup">
        <label>Recibo Consignación</label>

        <input
          type="text"
          v-model.trim="selectedRecibConsig"
          placeholder="Ingrese el recibo"
          required
        />
      </div>

      <div class="formActions">
        <button type="submit" class="loginbtn primaryBtn">
          Buscar
        </button>
      </div>

    </form>

  </div>
</template>
<script>
//Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'

  export default {
    components: {
        IberoHelpers,
    },
    data () {
      return {
        selectedPeriod : null,
        selectedClient: null,
        selectedRecibConsig: null,
        orderData : [],
      }
    },
    methods: {
        
        //Método que carga los datos de las ordenes desde Iceberg, se le pasa "Concepto Nota", como parámetro
        async loadOrderData() {
          try {
            let response = await IberoHelpers.GetReciboConsignacionIceberg(this.$store, this.selectedPeriod, this.selectedClient, this.selectedRecibConsig);

            if (response.data.length === 0) {
              this.orderData = [{
                Registro: 0,
                Secuencia: 0,
                ColumnName: "",
                ValorAnterior: "",
                ValorAccion: "",
                Accion: "",
                Fecha: "",
                Terminal: "",
                Usuario: "",
                ObjectName: ""
              }]; // Objeto por defecto
            } else {
              this.orderData = response.data;
            }
            this.$emit('showResultOrder', this.orderData);
          } catch (error) {
            console.error('Error loading data:', error);
          }
        }
        
    },
  }
</script>